import React, { useEffect } from "react";
import Button from "../../components/Button/Button";
import Input from "../../components/Input/Input";

import { useAuthContext } from "../../hooks/useAuthContext";

import styles from "./Login.module.css";

import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useFetch } from "../../hooks/useFetch";
import { baseURL } from "../../components/utils/utils";

const Login = () => {
  //const baseURL = "http://localhost/_API_2_/usuarios/";
  const { httpRequest, error, setError } = useFetch(`${baseURL}/usuarios/`);
  const { loading, setUser, user } = useAuthContext();

  const [UsuEmail, setEmail] = useState("samuka@email.com.br");
  const [UsuSenha, setSenha] = useState("123");
  // const [usuario, setUsuario] = useState(UsuSenha, UsuEmail);
  const [formError, setFormError] = useState(false);

  const navigate = useNavigate();

  useEffect(() => {
    if (user && user.token && user !== null) {
      navigate("/");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user]);

  const handleLogin = async () => {
    const nUser = validaCampos();
    if (nUser) {
      const data = await httpRequest(nUser, null, "login");
      if (data) {
        console.log(data);
        localStorage.setItem("user", JSON.stringify(data));
        setUser(data);
      }
    }
  };

  const validaCampos = () => {
    const d = {
      UsuEmail,
      UsuSenha
    };
    if (d.UsuEmail === "") {
      setFormError("Informar um e-mail!");
      return false;
    }
    if (d.UsuSenha === "") {
      setFormError("Informar a senha!");
      return false;
    }
    return d;
  };

  return (
    <div className={styles.container_login}>
      <h1 className={styles.title}>Login</h1>
      <div className={styles.content}>
        <Input
          label="E-mail"
          id="UsuEmail"
          type="email"
          placeholder="Digite seu E-mail"
          value={UsuEmail}
          onChange={(e) => [
            setEmail(e.target.value),
            setFormError(""),
            setError("")
          ]}
        />
        <Input
          label="Senha"
          id="UsuSenha"
          type="password"
          placeholder="Digite sua Senha"
          value={UsuSenha}
          onChange={(e) => [
            setSenha(e.target.value),
            setFormError(""),
            setError("")
          ]}
        />
        {loading && <p className={styles.loading}>Carregando...</p>}
        {error && <p className={styles.error}>{error}</p>}
        {formError && <p className={styles.error}>{formError}</p>}
        <Button texto="Entrar" onClick={handleLogin} active={true} />
        <p className={styles.p}>
          Não tem conta?
          <strong>
            <Link to="/users">&nbsp;Registre-se</Link>
          </strong>
        </p>
      </div>
    </div>
  );
};
export default Login;
